import React from "react";
import { useLocation } from "react-router-dom";
import Seo, { ORGANIZATION_JSON_LD, SOFTWARE_APP_JSON_LD } from "./Seo";

// Route-level SEO for the fixed PUBLIC pages, mounted once inside the Router.
// Descriptions are written as complete liftable answers (audit Phase 1/5).
// Dynamic pages (blog posts, and Phase 3's story pages) render their own
// <Seo> deeper in the tree, which wins over this one in react-helmet.
const META = {
  "/": {
    title: "Pixley — Turn Kids' Drawings into Cartoons & Personalized Stories",
    description:
      "Pixley turns your child's drawings and photos into animated cartoon characters, then stars them in personalized video stories, bedtime storybooks, and learning games. Built for ages 2-8, safe by design, free to try on iOS and the web.",
    jsonLd: [ORGANIZATION_JSON_LD, SOFTWARE_APP_JSON_LD],
  },
  "/storyverse": {
    title: "Storyverse — Free Kids' Cartoons & Stories to Watch | Pixley",
    description:
      "Watch free kids' cartoons and stories in the Pixley Storyverse: original shows like Zippy the Little Pilot plus community-made stories about kindness, sharing, and bedtime — all safe, ad-free, and made for ages 2-8.",
  },
  "/blog": {
    title: "Pixley Blog — Screen Time, Stories & Early Learning for Parents",
    description:
      "Practical guides for parents on healthy screen time, choosing safe digital content, and using stories to build emotional intelligence and early learning skills in kids ages 2-8.",
  },
  "/download": {
    title: "Download Pixley — Kids' Story & Cartoon Maker for iOS",
    description:
      "Download Pixley on the App Store to turn your child's drawings into cartoon characters and personalized stories. Free to download; works on iPhone and iPad.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | Pixley",
    description:
      "How Pixley collects, uses, and protects your family's data, including our COPPA-aligned practices for children's privacy.",
  },
  "/auth": {
    title: "Sign In or Create Your Pixley Account",
    description:
      "Sign in to Pixley or create a free account to start turning your child's drawings into cartoon characters and personalized stories.",
    // Sign-in has no search value: noindex here, and out of the sitemap
    // (scripts/seo-routes.js).
    robots: "noindex",
  },
  "/games/bubble-pop": {
    title: "Bubble Pop — Free Kids' Counting Game | Pixley",
    description:
      "Play Bubble Pop, a free counting game for kids from Pixley. Pop the bubbles, beat your friend's score, and practice numbers - no download needed.",
  },
};

const RouteSeo = () => {
  const { pathname } = useLocation();
  const meta = META[pathname === "/privacypolicy" ? "/privacy-policy" : pathname];
  if (!meta) return null;
  return (
    <Seo
      title={meta.title}
      description={meta.description}
      path={pathname}
      jsonLd={meta.jsonLd || null}
      robots={meta.robots || null}
    />
  );
};

export default RouteSeo;
